<template>
  <div class="wrapper-page">
    <div id="header" class="wrapper-bg-header">
      <div class="banner-text">
        <div v-if="isSteel">เหล็ก&nbsp;</div>
        <div style="color: rgb(243, 200, 23); font-weight:700">{{title}}</div>
      </div>
    </div>
    <div style="background:#ededed;">
      <div id="allproduct" class="container content-container">
        <div class="row product-block" v-if="products && products.length > 0">
          <ProductCard
            v-for="p in products"
            :key="p.name"
            :name="p.name"
            :category="p.category"
            :description="p.description"
            :image="p.image"
          ></ProductCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import data from "@/services/data.js";
import ProductCard from "@/components/ProductCard";
import service from "@/services/service.js";
import { ALLINTRO } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "home",
  data() {
    return {
      datas: []
    };
  },
  components: {
    ProductCard
  },
  computed: {
    ...mapGetters(["getAllIntro"]),
    isSteel() {
      return this.$route.params.category.indexOf("เหล็ก") === 0
    },
    title() {
      return this.isSteel ? this.$route.params.category.slice(this.$route.params.category.lastIndexOf("เหล็ก") + "เหล็ก".length ) : this.$route.params.category;
    },
    products() {
      return this.getAllIntro.filter(p => p.category === this.$route.params.category);
    }
  },
  methods: {
    scrollToView() {
      window.scroll({
        top: document.getElementById("header").clientHeight,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style scoped>
h2 {
  text-align: center;
  margin-bottom: 30px;
  font-weight: 600;
}
.product-block {
  width: 100%;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 1050px;
  align-self: center;
  margin: 0; /*ตัวปัญหาแก้มากว่า 3 ชม.*/
}
.sponser-container {
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
}
.banner-page {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}


.logo {
  display: flex;
  flex-direction: column;
  animation: fade 0.5s, size 0.5s;
}

.image,
.image1 {
  width: 20%;
}

@keyframes size {
  from {
    transform: scale(2);
  }
  to {
    transform: scale(1);
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes lineWidthLeft {
  from {
    transform: scaleX(0);
    transform-origin: left center;
  }
  to {
    transform: scaleX(1);
    transform-origin: left center;
  }
}

@keyframes lineWidthRight {
  from {
    transform: scaleX(0);
    transform-origin: right center;
  }
  to {
    transform: scaleX(1);
    transform-origin: right center;
  }
}

.btn-darkblue {
  width: 200px;
  color: rgb(255, 255, 255);
  border: 2px solid rgb(243, 200, 23); /* Green */
  background-color: transparent;
  border-radius: 10px;
  margin: 10px 5px;
  animation: fade 1.5s;
}

.btn-darkblue:hover {
  background-color: rgb(243, 200, 23);
  color: #000;
  font-weight: 600;
  border: none;
}

@media screen and (max-width: 780px) {
  .banner-page {
    display: flex;
    flex-direction: column;
  }
  .banner-text {
    margin: auto;
  }
  .image1 {
    display: none;
  }
  .image1 {
    width: 30%;
  }
}

.line-break-left {
  display: flex;
  width: 200px;
  margin: 25px 10px;
  /* margin-bottom: 30px; */
  height: 1px;
  background: #fff !important;
  animation: lineWidthRight 1s;
}
.line-break-right {
  display: flex;
  width: 200px;
  margin: 25px 10px;
  /* margin-bottom: 30px; */
  height: 1px;
  background: #fff !important;
  animation: lineWidthLeft 1s;
}
</style>